import { render } from "./AllEvents.vue?vue&type=template&id=42992a2e"
import script from "./AllEvents.vue?vue&type=script&lang=js"
export * from "./AllEvents.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__